/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import {
  Box,
  Link,
  Drawer,
  Typography,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MastersIcon from '../../../media/masters.png';
import Quality from '../../../media/Quality.png';
import reports from '../../../media/reports.png';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
import './nav.css';
//
import Transactions from './Transactions';
import Sales from './Sales';
import Customer from './Customer';
import Masters from './Masters';
import MastersData from './MastersData';
import logoImage from '../../../media/login/logo.png';
import logo from '../../../media/BMS-logo1.png';
import Reports from './Reports';
// ----------------------------------------------------------------------

const NAV_WIDTH = 250;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2, 0),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.2),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  opennav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ opennav, onCloseNav }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isDesktop = useResponsive('up', 'lg');
  const [MasterScreens, setMasterScreens] = useState([]);
  const [TransactionScreens, setTransactionScreens] = useState([]);
  const [ReportScreens, setReportScreens] = useState([]);

  useEffect(() => {
    const accessMasterScreens = Masters.filter((screen) => sessionStorage.getItem(screen.ShortName));
    const accessTransactionScreens = Transactions.filter((screen) => sessionStorage.getItem(screen.ShortName));
    const accessReportScreens = Reports.filter((screen) => sessionStorage.getItem(screen.ShortName) );
    setMasterScreens(accessMasterScreens);
    setTransactionScreens(accessTransactionScreens);
    setReportScreens(accessReportScreens);
  }, []);

  useEffect(() => {
    if (!opennav) {
      onCloseNav();
    }
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ mb: 5, m: 1 }}>
        <Link underline="none">
          <StyledAccount>
            <button
              onClick={() => {
                console.log('Clicked on the logo');
                navigate('/dashboard');
              }}
              style={{
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={logoImage}
                style={{
                  objectFit: 'contain',
                  maxWidth: '35%',
                  borderRadius: '10px',
                  backgroundColor: '#ffffffe6',
                }}
                alt="brand logo"
              />
            </button>
          </StyledAccount>
        </Link>
      </Box>
      {MasterScreens.length > 0 && (
        <Accordion
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'inherit', backgroundColor: 'inherit', p: 0, m: 0 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
            style={{ margin: '1px 0 ' }}
            className="margincase"
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="white">
                <img src={MastersIcon} alt="M" style={{ color: 'white', width: 25, height: 25 }} />
              </IconButton>
              <Typography
                sx={{
                  color: 'white',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
              >
                Master
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pl: 6 }}>
            <NavSection data={MasterScreens} />
          </AccordionDetails>
        </Accordion>
      )}
      {TransactionScreens.length > 0 && (
        <Accordion
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'inherit', backgroundColor: 'inherit', p: 0, m: 0 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
            style={{ margin: '1px 0 ' }}
            className="margincase"
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="white">
                <img src={Quality} alt="M" style={{ color: 'white', width: 25, height: 25 }} />
              </IconButton>
              <Typography
                sx={{
                  color: 'white',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
              >
                Transactions
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pl: 6 }}>
            <NavSection data={TransactionScreens} />
          </AccordionDetails>
        </Accordion>
      )}

      {ReportScreens.length > 0 && (
        <Accordion
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'inherit', backgroundColor: 'inherit', p: 0, m: 0 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
            style={{ margin: '1px 0 ' }}
            className="margincase"
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="white">
                <img src={reports} alt="M" style={{ color: 'white', width: 25, height: 25 }} />
              </IconButton>
              <Typography
                sx={{
                  color: 'white',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
              >
                Reports
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pl: 6 }}>
            <NavSection data={ReportScreens} />
          </AccordionDetails>
        </Accordion>
      )}

      {/* {sessionStorage.getItem('userRole') === 'Admin' && sessionStorage.getItem('IsHeadOffice') === 'Y' && ( */}
      {/* {sessionStorage.getItem('userRole') === 'Admin' && (
        <Accordion
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'inherit', backgroundColor: 'inherit', p: 0, m: 0 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
            style={{ margin: '1px 0 ' }}
            className="margincase"
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="white">
                <img src={MastersIcon} alt="M" style={{ color: 'white', width: 25, height: 25 }} />
              </IconButton>
              <Typography
                sx={{
                  color: 'white',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
              >
                Manage
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pl: 6 }}>
            <NavSection data={Transactions} />
          </AccordionDetails>
        </Accordion>
      )}

      {sessionStorage.getItem('userRole') === 'Sales' && (
        <Accordion
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'inherit', backgroundColor: 'inherit', p: 0, m: 0 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
            style={{ margin: '1px 0 ' }}
            className="margincase"
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="white">
                <img src={MastersIcon} alt="M" style={{ color: 'white', width: 25, height: 25 }} />
              </IconButton>
              <Typography
                sx={{
                  color: 'white',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
              >
                Sales
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pl: 6 }}>
            <NavSection data={Sales} />
          </AccordionDetails>
        </Accordion>
      )}

      {sessionStorage.getItem('userRole') === 'Customer' && (
        <Accordion
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'inherit', backgroundColor: 'inherit', p: 0, m: 0 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
            style={{ margin: '1px 0 ' }}
            className="margincase"
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="white">
                <img src={MastersIcon} alt="M" style={{ color: 'white', width: 25, height: 25 }} />
              </IconButton>
              <Typography
                sx={{
                  color: 'white',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
              >
                Bookings
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pl: 6 }}>
            <NavSection data={Customer} />
          </AccordionDetails>
        </Accordion>
      )} */}

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: opennav ? NAV_WIDTH : 0 },
      }}
    >
      {isDesktop ? (
        <Drawer
          open={opennav}
          variant={opennav ? 'persistent' : 'temporary'}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              // bgcolor: '#091057'
              background: ' #47A992',
            },
          }}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={opennav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              // bgcolor: '#091057'
              background: ' #47A992',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
